<template>
  <div>
    <v-card height="100%">
      <v-card color="primary" @click="cardExpand = !cardExpand">
        <v-card-title class="card-title-text">{{ cardTitle }}</v-card-title>
      </v-card>
      <v-expand-transition>
        <v-container class="pt-3 px-4 pb-6" v-if="cardExpand">
          <v-form v-model="validForm" ref="form">
            <v-row>
              <template v-for="(item, index) in extraDataInfo">
                <v-col cols="12" :md="item.columSize != undefined
        ? item.columSize
        : extraInfoColumSize
        " class="checks-margin can-click-override">
                  <span class="text-subtitle"> {{ item.label }} </span>
                  <v-row>
                    <v-col>
                      <p class="label-text2" v-if="item.editEstado == 0">
                        <v-icon size="15" class="mr-1" v-if="item.dato != '' &&
        item.notEditable == false &&
        item.label != 'Apoderado Legal'
        " v-on:click="checkEditCampo(index, item)">
                          mdi-pencil
                        </v-icon>
                        {{ item.dato }}
                      </p>
                    </v-col>
                    <v-col>
                      <div v-if="item.iconValue == 0">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="red" dark v-bind="attrs" v-on="on">
                              mdi-account
                            </v-icon>
                          </template>
                          <span>El abogado no tiene el poder asignado</span>
                        </v-tooltip>
                      </div>
                      <div v-if="item.iconValue == 1">
                        <v-tooltip bottom>

                          <template v-slot:activator="{ on, attrs }">
                            <v-icon color="green" dark v-bind="attrs" v-on="on">
                              El abogado tiene el poder asignado
                            </v-icon>
                          </template>
                          <span>Tooltip</span>
                        </v-tooltip>
                      </div>
                    </v-col>
                  </v-row>
                  <div v-if="editingCampo == true">
                    <div v-if="item.editEstado == 1">
                      <div v-if="item.isCorralon != 1">
                        <v-text-field class="mx-1" label="" solo v-model="editTextFieldValue"
                          :rules="dynamicRulesGen(item, index)"></v-text-field>
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-icon v-on:click="
        editCampoSave(extraDataInfo[index], index)
        ">
                            mdi-content-save
                          </v-icon>
                          <span> </span>
                          <v-icon v-on:click="
        (extraDataInfo[index].editEstado = 0),
        (editingCampo = false)
        " class="mr-4">
                            mdi-cancel
                          </v-icon>
                        </v-row>
                      </div>
                      <div v-if="item.isCorralon == 1">
                        <v-select class="mx-1" solo :items="editCorralonItems" item-text="prnombre" item-value="prclave"
                          v-model="editTextFieldValue"></v-select>
                        <v-row>
                          <v-spacer></v-spacer>
                          <v-icon v-on:click="
        editCorralon(
          extraDataInfo[index],
          index,
          editTextFieldValue
        )
        ">
                            mdi-content-save
                          </v-icon>
                          <span> </span>
                          <v-icon v-on:click="
        (extraDataInfo[index].editEstado = 0),
        (editingCampo = false)
        " class="mr-4">
                            mdi-cancel
                          </v-icon>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-col>
              </template>
              <v-col cols="12" v-if="showDisposicionBox == true">
                <div>
                  <v-btn outlined :class="valueDisposicion == 1
        ? 'yesButton-style'
        : 'yesButton-unselected-style'
        " v-on:click="disposicionAutoridadCheckMov(1)">
                    <v-icon size="14" color="white" v-if="valueDisposicion == 1">mdi-check</v-icon>
                  </v-btn>
                  <v-btn outlined :class="valueDisposicion == 0
        ? 'noButton-style'
        : 'noButton-unselected-style'
        " v-on:click="disposicionAutoridadCheckMov(0)">
                    <v-icon size="14" color="white" v-if="valueDisposicion == 0">mdi-check</v-icon>
                  </v-btn>
                  <span class="movimiento-style-text">
                    A Disposición de la autoridad
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-form>
          <v-row v-if="subTitlesData.length == 0">
            <v-col cols="12" md="12">
              <div class="buttons-for-checks my-3" v-for="(item, index) in checkBoxesInfo" :key="index">
                <div v-if="item.visible == true" :class="[1, 13, 354, 380, 474, 558, 566].includes(
        item.claveMovimiento
      ) == true
        ? canOnlyInsertQuerella == true
          ? 'can-click-override'
          : 'false-canInsert'
        : [755, 756].includes(
          item.claveMovimiento
        ) == true ? 'can-click-override' : 'test'
        ">
                  <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
        ? 'yesButton-style'
        : 'yesButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                  </v-btn>
                  <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 0)" outlined :class="item.respuestaNO == 'true'
        ? 'noButton-style'
        : 'noButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaNO == 'true'">mdi-check</v-icon>
                  </v-btn>

                  <v-btn v-if="item.tipoRespuesta == 1" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
        ? 'yesButton-style'
        : 'yesButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                  </v-btn>
                  <v-btn v-if="item.tipoRespuesta == 1" class="invisible-button-style" disabled plain>
                  </v-btn>

                  <v-btn v-if="item.tipoRespuesta == 0" class="invisible-button-style" disabled plain>
                  </v-btn>

                  <v-btn v-if="item.tipoRespuesta == 0" v-on:click="movimientoTryPush(item, 0)" outlined :class="item.respuestaNO == 'true'
        ? 'noButton-style'
        : 'noButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaNO == 'true'">mdi-check</v-icon>
                  </v-btn>

                  <span class="movimiento-style-text capitalize-words">
                    {{ item.nombre.toLowerCase() }}</span>
                  <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta1.length > 0">
                    {{ item.etiqueta1 }}
                  </v-chip>
                  <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta2 != ''">
                    $ {{ item.etiqueta2 }}
                  </v-chip>
                  <!--<v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                    <v-icon left small v-if="item.editable == 1" v-on:click="showEditSwal(item, index)">
                      mdi-pencil
                    </v-icon>
                    {{ item.etiqueta3 }}
                  </v-chip>-->
                </div>
                <v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                  <v-icon left small v-if="item.editable == 1 && canInsertMoves == true"
                    v-on:click="showEditSwal(item, index)">
                    mdi-pencil
                  </v-icon>
                  {{ item.etiqueta3 }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="subTitlesData.length > 0">
            <v-col cols="12" :md="checkBoxesColumSize" v-for="(items, index) in subTitlesData" :key="index">
              <h1 class="text-center checkbox-title-text">{{ items }}</h1>
              <div class="buttons-for-checks my-3" v-for="(item, index) in checkBoxesInfo" :key="index">
                <!-- TODO: define if its yes/now checkboxes -->
                <div v-if="item.visible == true && item.Tipo == items" :class="[1, 13, 354, 380, 474, 558, 566].includes(item.claveMovimiento) ==
        true
        ? canOnlyInsertQuerella == true
          ? 'can-click-override'
          : 'false-canInsert'
        : [755, 756].includes(
          item.claveMovimiento
        ) == true ? 'can-click-override' : 'test'
        ">
                  <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
        ? 'yesButton-style'
        : 'yesButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                  </v-btn>
                  <v-btn v-if="item.tipoRespuesta == 2" v-on:click="movimientoTryPush(item, 0)" outlined :class="item.respuestaNO == 'true'
        ? 'noButton-style'
        : 'noButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaNO == 'true'">mdi-check</v-icon>
                  </v-btn>

                  <v-btn v-if="item.tipoRespuesta == 1" v-on:click="movimientoTryPush(item, 1)" outlined :class="item.respuestaSI == 'true'
        ? 'yesButton-style'
        : 'yesButton-unselected-style'
        ">
                    <v-icon size="14" color="white" v-if="item.respuestaSI == 'true'">mdi-check</v-icon>
                  </v-btn>

                  <v-btn v-if="item.tipoRespuesta == 1" class="invisible-button-style" disabled plain>
                  </v-btn>
                  <span class="movimiento-style-text"> {{ item.nombre }}</span>
                  <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta1.length > 0">
                    {{ item.etiqueta1 }}
                  </v-chip>
                  <v-chip class="mx-1 tags-margin" color="#4caf " outlined small v-if="item.etiqueta2 != ''">
                    $ {{ item.etiqueta2 }}
                  </v-chip>
                  <!--<v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                    <v-icon left small v-if="item.editable == 1" v-on:click="showEditSwal(item, index)">
                      mdi-pencil
                    </v-icon>
                    {{ item.etiqueta3 }}
                  </v-chip>-->
                </div>
                <v-chip class="mx-1 tags-margin" color="#ff4569" label dark small v-if="item.etiqueta3.length > 0">
                  <v-icon left small v-if="item.editable == 1" v-on:click="showEditSwal(item, index)">
                    mdi-pencil
                  </v-icon>
                  {{ item.etiqueta3 }}
                </v-chip>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-expand-transition>
    </v-card>
    <v-dialog transition="dialog-top-transition" max-width="600" v-model="libVehDialog" persistent>

      <template>
        <v-card>
          <v-toolbar color="#ef6c00" dark>
            <v-toolbar-title>Detener Vehículo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon @click="libVehDialog = false">mdi-close-box</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="validForm" ref="form">
              <v-row class="mt-4">
                <v-col cols="12" md="12">
                  <v-text-field label="Firma electronica:" v-model="efirma" filled :rules="efirmaRules" type="password"
                    :error-messages="eFirmaErrormessage"></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <span> Estuvo a disposición de la autoridad </span>
                  <v-radio-group v-model="disposicionAutoridadCheck" row :rules="disposicionAutoridadRules">
                    <v-radio label="SI" :value="true"></v-radio>
                    <v-radio label="NO" :value="false"></v-radio>
                  </v-radio-group>

                  <div v-if="disposicionAutoridadCheck == false">
                    <span> El vehiculo esta en corralón: </span>
                    <v-radio-group v-model="vehiculoCorralon" row :rules="disposicionAutoridadRules">
                      <v-radio label="SI" :value="true"></v-radio>
                      <v-radio label="NO" :value="false" v-if="disposicion"></v-radio>
                    </v-radio-group>
                  </div>
                </v-col>

                <v-col cols="12" md="12" v-if="vehiculoCorralon == false">
                  <span> Motivo no liberación: </span>
                  <v-select filled :items="motivoNoLibItems" v-model="motivoNoLibSelected" item-text="text"
                    item-value="id" placeholder="Falta Documentación" :rules="motivoNoLibRules"></v-select>
                </v-col>
              </v-row>
            </v-form>
            <!-- TODO: HERE GOES THE TEXT-->
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-spacer></v-spacer>
            <v-btn color="success" @click="detenerVehValid()">Guardar</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import reporteExpJur from "@/services/ExpJur/ExpJur.service.js";
import reporteMovimientos from "@/services/Movimientos/Movimientos.service.js";
import generalServices from "@/services/ReporteGeneral/ReporteGeneral.service.js";
import { mapState } from 'vuex';

export default {
  props: [
    "cardTitle",
    "subTitlesData",
    "checkBoxesInfo",
    "extraDataInfo",
    "fatherColumSize",
    "showDisposicion",
    "valueDisposicion",
    "canInsertMoves",
    "canOnlyInsertQuerella",
    "reporteInfo",
    "esPrestacionEspe",
    "tipoProceso"
  ],
  data() {
    return {
      disposicion: false,
      extraInfoColumSize: 6,
      checkBoxesColumSize: 12,
      editTextFieldValue: [],
      editingCampo: false,

      cardExpand: true,

      validForm: true,
      libVehDialog: false,
      efirma: "",
      disposicionAutoridadCheck: null,
      vehiculoCorralon: null,
      motivoNoLibItems: [],
      motivoNoLibSelected: "",
      showDisposicionBox: false,

      editCorralonItems: [],

      efirmaRules: [(v) => !!v || "Campo requerido"],
      disposicionAutoridadRules: [(v) => v != null || "Campo requerido"],
      motivoNoLibRules: [(v) => !!v || "Campo requerido"],

      eFirmaErrormessage: "",
      datos: [],
    };
  },
  watch: {
    efirma(val) {
      this.eFirmaErrormessage = "";
    },
    disposicionAutoridadCheck(val) {
      this.vehiculoCorralon = null;
      this.motivoNoLibSelected = null;
    },
    vehiculoCorralon(val) {
      this.motivoNoLibSelected = null;
    },
  },
  computed: {
    ...mapState(['domain', 'informationPage']),
  },
  async mounted() {
    this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
    this.showDisposicionValider(this.showDisposicion)
    this.obtenerCorralones();
  },
  methods: {
    formattNames(nameString) {
      let nameStringTemp = nameString.toString();
      try {
        nameStringTemp.toLowerCase();
      } catch (e) {
        return nameString;
      }
      return nameStringTemp;
    },

    async showDisposicionValider(item) {
      let nextStep = true;
      let response = false;

      if (item == null || item == undefined) {
        nextStep = false;
        this.showDisposicionBox = false;
        response = false;
      }

      if (item == true) {
        nextStep = false;
        this.showDisposicionBox = true;
        response = true;
      }

      let responseComprobar = await reporteMovimientos.MovimientosReporteComprobarPrestacion(this.reporteInfo);
      let esPrestacionEspecial = responseComprobar[0].esEspecial

      if (nextStep == true) {
        if (esPrestacionEspecial != 1) {
          if (this.reporteInfo.aiclave == 1 || this.reporteInfo.aiclave == 23 || this.reporteInfo.aiclave == 27) {
            response = false;
          } else {
            if (item.astipo == 2) {
              if (item.asparte == 1) {
                response = true;
              } else {
                response = false;
              }
            } else {
              response = false;
            }
          }
        }
      }
      this.showDisposicionBox = response;
      return response;
    },

    async obtenerCorralones() {
      let response = await reporteExpJur.obtenerCorralones(this.datos);
      this.editCorralonItems = response;
    },

    dynamicRulesGen(item, index) {
      var resultRules = [];
      try {
        if (item.minLength >= 1) {
          resultRules.push((v) => {
            if (v == null || v == "") {
              return true;
            } else {
              if (v.trim().length < item.minLength) {
                return `Mínimo ${item.minLength} Carácteres`;
              } else if (v.trim().length > item.maxLength) {
                return `Máximo ${item.maxLength} Carácteres`;
              } else return true;
            }
          });
        }
      } catch (e) {
        console.log("exepc:", e);
      }
      return resultRules;
    },

    async editCorralon(item, index, value) {
      if (typeof value == "object") {
        this.$swal({
          position: "center",
          icon: "error",
          title: "El campo no puede estar vacío",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.editTextFieldValue = null;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
        return;
      }
      let foundItem = this.editCorralonItems.find((o) => o.prclave === value);
      let newText = foundItem.prnombre;
      let oldText = item.dato;
      newText = newText.trim();

      //LOADING DIALOG
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento por favor",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirm: false,
      });

      this.$swal.showLoading();

      if (newText == "" || newText == null || newText == undefined) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "El campo no puede estar vacío",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.editTextFieldValue = null;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
        return;
      }

      // PROCESO DE EDICION
      const editCampoResponse = await reporteExpJur.actualizaCorralon(
        this.datos,
        value
      );

      this.editTextFieldValue = "";
      if (editCampoResponse) {
        this.$swal({
          position: "center",
          icon: "success",
          title: "Campo editado correctamente",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = newText;
        this.extraDataInfo[index].editEstado = 0;
        this.extraDataInfo[index].value = value;
      } else {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Error al editar el campo",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
      }
    },

    async detenerVeh(ceclave) {
      this.efirma = "";
      this.disposicionAutoridadCheck = null;
      this.motivoNoLibSelected = "";

      if (ceclave == 747) {
        this.disposicion = true;
        this.vehiculoCorralon = null;
      } else {
        this.disposicion = false;
      }
      this.$refs.form.resetValidation();
      //NECESITA EL PERMISO 153
      let responsePermiso = await MetodosGenerales.verificarPermisoSolo(
        this.domain.domainNameForApi,
        "VerificarPermiso",
        "153"
      );

      if (responsePermiso.data.length == 0) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Sin permisos",
          html: "Lo sentimos, no tienes el permiso necesario para realizar esta acción, si crees que esto es un error contacta a soporte",
          showConfirmButton: true,
          timer: 5000,
        });
        return;
      }

      //TODO: OPEN A LOADING ALERT HERE
      let entryTypeResponse = await reporteExpJur.reporteObtenerEditCampoInfo(
        this.datos,
        1
      );
      var selectItems = await JSON.parse(entryTypeResponse[0].selectItems);
      this.motivoNoLibItems = selectItems;

      this.libVehDialog = true;
    },

    checkItemQuerella(item) {
      if (this.canOnlyInsertQuerella == true && item.claveMovimiento == 1) {
        return "can-click-override";
      }
    },

    async detenerVehValid() {
      this.$refs.form.validate();
      let valid = this.$refs.form.validate();
      if (valid == true) {
        let eFirmaValidResponse = await reporteMovimientos.ValidarEFirma(
          this,
          this.efirma
        );

        if (eFirmaValidResponse.length == 1) {
          this.$swal({
            position: "center",
            title: "Guardando...",
            html: "Espere un momento por favor",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
              this.changeVehDetenido();
            },
          });
        } else {
          this.eFirmaErrormessage = "Firma electronica incorrecta";
          return;
        }
      }
    },

    async changeVehDetenido() {
      let changeResponse = await reporteMovimientos.changeLibVehRobo(
        this,
        this.efirma,
        this.disposicionAutoridadCheck,
        this.vehiculoCorralon,
        this.motivoNoLibSelected,
        this.disposicion
      );

      this.$swal({
        position: "center",
        icon: "success",
        title: "Exito!",
        html: "El campo se edito correctamente",
        showConfirmButton: true,
        timer: 5000,
      }).then(() => {
        window.location.reload();
      });
    },

    async showEditSwal(item, index) {
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento por favor",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirm: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let entryTypeResponse = await reporteExpJur.reporteObtenerEditCampoInfo(
        this.datos,
        item.ieapid
      );

      if (entryTypeResponse[0].validEntry == 1) {
        if (entryTypeResponse[0].ieaptipo == "select") {
          var selectItems = await JSON.parse(entryTypeResponse[0].selectItems);

          var options = {};
          selectItems.forEach((element) => {
            options[element.id] = element.text;
          });

          this.$swal.close();
          this.$swal({
            title: "Motivo no liberación",
            input: "select",
            inputOptions: options,
            inputAttributes: {
              style: "background-color: #d1d1e0 !important;",
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Editar",
            showLoaderOnConfirm: true,
            allowOutsideClick: () => !this.$swal.isLoading(),
          }).then(async (result) => {
            if (result.isConfirmed) {
              let editResponse = await reporteExpJur.reporteEditCampoInfo(
                this.datos,
                item.ieapid,
                result.value
              );

              if (editResponse[0].EditSuccess == 1) {
                this.checkBoxesInfo[index].etiqueta3 = options[result.value];
                this.$swal({
                  position: "center",
                  icon: "success",
                  title: "Exito!",
                  html: "El campo se editó correctamente",
                  showConfirmButton: true,
                  timer: 5000,
                }).then(() => {
                  window.location.reload();
                });

                return;
              }
              this.$swal({
                position: "center",
                icon: "error",
                title: "Error al editar el campo",
                html: "Error al editar el campo, intente de nuevo, si el problema persiste, contacte a soporte",
                showConfirmButton: true,
                timer: 5000,
                confirmButtonText: "Vale!",
                allowOutsideClick: false,
              });
            }
          });
          return;
        }
        this.$swal({
          position: "center",
          icon: "error",
          title: "Opss... algo salio mal",
          html: "Error al obtener el tipo de entrada, intente de nuevo, si el problema persiste, contacte a soporte",
          showConfirmButton: true,
          confirmButtonText: "Vale!",
          allowOutsideClick: false,
          timer: 5000,
        });
      }
    },
    checkEditCampo(index, item) {
      //if (item.isCorralon == 1) {
      //    this.editTextFieldValue = item.value;
      //}
      if (this.editingCampo == true) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "No puede editar otro campo mientras uno este en edición",
          showConfirmButton: true,
          confirmButtonText: "Vale!",
          timer: 4000,
          allowOutsideClick: false,
        });
        return;
      } else {
        this.extraDataInfo[index].editEstado = 1;
        this.editingCampo = true;
        if (item.isCorralon == 1) {
          this.editTextFieldValue = item.value;
        } else {
          this.editTextFieldValue = item.dato;
        }
      }
    },
    resizeColums() {
      if (this.subTitlesData.length > 0) {
        if (this.subTitlesData.length > 3) {
          this.checkBoxesColumSize = 4;
        } else {
          this.checkBoxesColumSize = 12 / this.subTitlesData.length;
        }
      }

      if (this.fatherColumSize > 6) {
        this.extraInfoColumSize = 6;
      } else {
        this.extraInfoColumSize = 12;
      }
    },
    async editCampoSave(item, index) {
      let newText = this.editTextFieldValue;
      let oldText = item.dato;
      this.$refs.form.validate();
      let valid = this.$refs.form.validate();
      if (!valid) {
        return;
      }

      if (newText == "" || newText == null || newText == undefined) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "El campo no puede estar vacío",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.editTextFieldValue = null;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
        return;
      }

      newText = newText.trim();

      //LOADING DIALOG
      this.$swal({
        position: "center",
        title: "Cargando...",
        html: "Espere un momento por favor",
        allowOutsideClick: false,
        allowEscapeKey: false,
        confirm: false,
      });

      this.$swal.showLoading();

      if (newText == "" || newText == null || newText == undefined) {
        this.$swal({
          position: "center",
          icon: "error",
          title: "El campo no puede estar vacío",
          showConfirmButton: false,
          timer: 5000,
        });
        this.editingCampo = false;
        this.editTextFieldValue = null;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
        return;
      }

      // PROCESO DE EDICION
      const editCampoResponse = await reporteExpJur.editCampo(
        this.datos,
        item.tabla,
        item.campo,
        newText
      );

      this.editTextFieldValue = "";
      if (editCampoResponse) {
        this.$swal({
          position: "center",
          icon: "success",
          title: "Campo editado correctamente",
          showConfirmButton: true,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = newText;
        this.extraDataInfo[index].editEstado = 0;
      } else {
        this.$swal({
          position: "center",
          icon: "error",
          title: "Error al editar el campo",
          showConfirmButton: true,
          timer: 5000,
        });
        this.editingCampo = false;
        this.extraDataInfo[index].dato = oldText;
        this.extraDataInfo[index].editEstado = 0;
      }
    },

    async disposicionAutoridadCheckMov(respuesta) {
      if (this.valueDisposicion == respuesta) {
        return;
      }

      //TODO: HACER AQUI UN LOADING EN LO QUE SE VERIFICA LA INFO:
      this.$swal({
        position: "center",
        title: "Verificando, espere un momento....",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      //TODO: Make this.
      let validaMovimientoDisposicionAutoridad =
        await reporteExpJur.validaDisposicion(this.datos);

      if (validaMovimientoDisposicionAutoridad[0].valida == 1) {
        setTimeout(() => {
          this.$swal.close();
          this.detenerVeh(747);
        }, 500);
        return;
      }

      setTimeout(() => {
        this.$swal.close();
        this.$swal({
          position: "center",
          icon: "warning",
          title: "No tan rapido...",
          html: "Este movimiento lo debe ingresar Líderes de Primera Atención",
          showConfirmButton: true,
        });
      }, 2000);

      // try {
      //   let result = validaMovimientoDisposicionAutoridad[0];

      //   if (result.puedeInsertar == 1) {
      //     var toToken = {
      //       claveMovimiento: item.claveMovimiento,
      //       respuesta: respuesta,
      //     };
      //     let token = MetodosGenerales.generateJsonToken(toToken);
      //     this.$swal.close();
      //     this.$router.push({
      //       name: `AgregarMovimientoExpJur`,
      //       params: {
      //         tokenData: token,
      //       },
      //     });
      //   } else {
      //     let errorMessage =
      //       "Antes de insertar este movimiento necesita:" +
      //       "<br /> " +
      //       "<b> " +
      //       result.concepto +
      //       "</b>";
      //     this.$swal.close();
      //     this.$swal({
      //       position: "center",
      //       icon: "error",
      //       title: "Movimiento Faltante",
      //       html: errorMessage,
      //       showConfirmButton: true,
      //     });
      //   }
      // } catch (e) {
      //   this.$swal.close();
      //   this.$swal({
      //     position: "center",
      //     icon: "error",
      //     title: "Opss... algo salio mal",
      //     html: "Error al verificar el movimiento, intente de nuevo, si el problema persiste contacte a soporte",
      //     showConfirmButton: true,
      //   });
      // }
    },

    async movimientoTryPush(item, respuesta) {
      let cancontinue = 1;
      if (this.canOnlyInsertQuerella) {
        if (![1, 13, 354, 380, 474, 558, 566].includes(item.claveMovimiento)) {
          return;
        }
      }

      if (item.claveMovimiento == 3 && respuesta == 0) {
        this.detenerVeh(3);
        return;
      }

      let canLibVeh = true;

      if ((item.claveMovimiento == 3 || item.claveMovimiento == 542 || item.claveMovimiento == 754) && respuesta == 1) {
        let responsePermiso = await MetodosGenerales.verificarPermisoSolo(
          this.domain.domainNameForApi,
          "VerificarPermiso",
          "168"
        );

        if (responsePermiso.data.length == 0) {
          canLibVeh = false;
          this.$swal({
            position: "center",
            icon: "error",
            title: "Sin permisos",
            html: "Lo sentimos, no tienes el permiso necesario para realizar esta acción, si crees que esto es un error contacta a soporte",
            showConfirmButton: false,
            timer: 5000,
          });

          return;
        }
      }

      if (canLibVeh == false) {
        return;
      }

      let moreThanOne = false;
      if (this.reporteInfo.multinsertceclave != undefined) {
        if (this.reporteInfo.multinsertceclave.includes(item.claveMovimiento)) {
          moreThanOne = true; //SI EL MOVIMIENTO TIENE POSIBILIDAD DE INSERTAR MAS DE 1 VEZ en SI El LOS CECLAVES
        }
      }

      if (item.respuestaSI == "true" && moreThanOne == false) {
        return; //SI EL MOVIMIENTO YA TIENE UNA RESPUESTA EN SI, NO HACER NADA
      }

      //if (respuesta == 0 && item.claveMovimiento == 2) {
      //  return; // SI INTENTA INGRESAR LIBERACION DEL CONDUCTOR EN NO --> REGRERSARLO
      //}

      if (respuesta == 0 && item.claveMovimiento != 746 && item.claveMovimiento != 852 && item.claveMovimiento != 854 && item.claveMovimiento != 857) {
        let datosReporte = await MetodosGenerales.obtenerSessionReporte(
          "reporte"
        );
        var toToken = {
          nrreporte: datosReporte.nrreporte,
          svindice: datosReporte.svindice,
          aiclave: datosReporte.aiclave,
          claveMovimiento: item.claveMovimiento,
          respuesta: respuesta,
        };
        let token = MetodosGenerales.generateJsonToken(toToken);
        let currentRoute = this.$route.path;
        let currentRouteFormatted = currentRoute.slice(
          0,
          currentRoute.lastIndexOf("/")
        );

        let movimientoRoute =
          currentRouteFormatted + "/AgregarMovimientos/" + token;

        this.$swal.close();
        this.$router
          .push({
            path: movimientoRoute,
            params: {
              tokenData: token,
            },
          })
          .catch((error) => error);
        return;
      }

      //TODO: HACER AQUI UN LOADING EN LO QUE SE VERIFICA LA INFO:
      this.$swal({
        position: "center",
        title: "Verificando, espere un momento....",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      if (respuesta == 1 && item.claveMovimiento == 753) {
        let datosReporte = await MetodosGenerales.obtenerSessionReporte(
          "reporte"
        );
        let responseValidRequiredDoctos =
          await generalServices.ObtenerDoctosPagosLibVeh(datosReporte);

        let pagoPension = responseValidRequiredDoctos[0].pagoPension;
        let pagoGrua = responseValidRequiredDoctos[0].pagoGrua;
        let pagoMulta = responseValidRequiredDoctos[0].pagoMulta;

        if (pagoPension == 1 || pagoGrua == 1 || pagoMulta == 1) {
          cancontinue = 0;

          let resultText =
            pagoPension == 1 ? " - Documento Pago/Pensión <br />" : "";

          resultText =
            resultText + (pagoGrua == 1 ? " - Documento Pago/Grúa <br />" : "");

          resultText =
            resultText +
            (pagoMulta == 1 ? " - Documento Pago/Multa <br />" : "");

          this.$swal.close();
          this.$swal({
            position: "center",
            icon: "error",
            title: "Documentos Faltantes",
            html:
              "<p class='text-center'> Para poder acceder es necesario tener los siguientes requisitos <br />  <br /> </p>" +
              "<p class='text-left'> " +
              resultText +
              "</p>",
            showConfirmButton: true,
          });
          return;
        }
      }

      if (cancontinue == 1) {
        let validMovimientoResponse = await reporteExpJur.validaNuevoMovimiento(
          this.datos,
          item.claveMovimiento,
          respuesta,
          this.tipoProceso != undefined ? this.tipoProceso : 0,
        );
        try {
          let result = validMovimientoResponse[0];
          if (result.puedeInsertar == 1) {

            let vehLibConstancia = true;

            if ((item.claveMovimiento == 3 || item.claveMovimiento == 542) && respuesta == 1) {
              let datosReporte = await MetodosGenerales.obtenerSessionReporte(
                "reporte"
              );
              let validaConstancia =
                await generalServices.ValidarConstanciaLiberacionVeh(datosReporte);
              if (validaConstancia.val == 0) {
                vehLibConstancia = false;
                await this.$swal({
                  position: "center",
                  icon: "warning",
                  title: "Sin constancia",
                  html: "Estás liberando el vehículo, pero el reporte no cuenta con el documento: Constancia de lib. del vehículo, deseas continuar?",
                  showCancelButton: true,
                  showConfirmButton: true,
                  cancelButtonText: "Cancelar",
                  confirmButtonText: "Continuar!",
                }).then((result) => {
                  if (result.isConfirmed) {
                    vehLibConstancia = true;
                  } else {
                    vehLibConstancia = false;
                  }
                });
              }
            }
            if (vehLibConstancia == true) {
              let datosReporte = await MetodosGenerales.obtenerSessionReporte(
                "reporte"
              );
              var toToken = {
                nrreporte: datosReporte.nrreporte,
                svindice: datosReporte.svindice,
                aiclave: datosReporte.aiclave,
                claveMovimiento: item.claveMovimiento,
                respuesta: respuesta,
              };
              let token = MetodosGenerales.generateJsonToken(toToken);
              let currentRoute = this.$route.path;
              let currentRouteFormatted = currentRoute.slice(
                0,
                currentRoute.lastIndexOf("/")
              );

              let movimientoRoute =
                currentRouteFormatted + "/AgregarMovimientos/" + token;
              this.$swal.close();
              this.$router
                .push({
                  path: movimientoRoute,
                  params: {
                    tokenData: token,
                  },
                })
                .catch((error) => console.log("El Error al hacer push: ", error));
            }
          } else {
            let errorMessage =
              "Antes de insertar este movimiento necesita:" +
              "<br /> " +
              "<b> " +
              result.concepto +
              "</b>";
            this.$swal.close();
            this.$swal({
              position: "center",
              icon: "error",
              title: "Movimiento Faltante",
              html: errorMessage,
              showConfirmButton: true,
            });
          }
        } catch (e) {
          this.$swal.close();
          this.$swal({
            position: "center",
            icon: "error",
            title: "Opss... algo salio mal",
            html: "Error al verificar el movimiento, intente de nuevo, si el problema persiste contacte a soporte",
            showConfirmButton: true,
          });
        }
      }
    },
  },
  beforeMount() {
    this.resizeColums();
  },
};
</script>


<style>
.nopadding-style .vs-collapse-item--header {
  padding: 0px !important;
}

.can-click-override {
  pointer-events: all !important;
}

.capitalize-words {
  display: inline-block;
}

.capitalize-words::first-letter {
  text-transform: capitalize !important;
}
</style>

<style scoped>
.collapsable-container {
  background: transparent !important;
  height: 100% !important;
}

.title-card-style {
  padding: 1.5px !important;
  max-height: auto;
}

.text-subtitle {
  font-family: "Poppins", sans-serif;
  font-size: 0.9em;
}

.card-title-text {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1em;
  color: white;
}

.label-text {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 12px !important;
}

.label-text2 {
  font-family: "Roboto", sans-serif;
  font-weight: 700 !important;
  font-size: 16px !important;
}

.checkbox-title-text {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 16px !important;
  color: #adb9ff;
}

.buttons-for-checks {
  margin-bottom: 3px !important;
}

.movimiento-style-text {
  font-family: "Roboto", sans-serif;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.checkbox-section-subtitle {
  font-family: "Roboto", sans-serif;
  font-weight: 800 !important;
  font-size: 14px !important;
  color: #004919;
}

.noButton-style {
  width: 25px !important;
  height: 25px !important;
  min-width: 25px !important;
  min-height: 25px !important;
  padding: 0 !important;
  margin-right: 5px;
  background-color: #f44336 !important;
  color: #f44336 !important;
}

.noButton-unselected-style {
  width: 25px !important;
  height: 25px !important;
  min-width: 25px !important;
  min-height: 25px !important;
  padding: 0 !important;
  margin-right: 5px;
  color: red !important;
}

.yesButton-style {
  width: 25px !important;
  height: 25px !important;
  min-width: 25px !important;
  min-height: 25px !important;
  padding: 0 !important;
  margin-right: 5px;
  background-color: #4caf !important;
  color: #4caf !important;

  /* #4caf */
}

.yesButton-unselected-style {
  width: 25px !important;
  height: 25px !important;
  min-width: 25px !important;
  min-height: 25px !important;
  padding: 0 !important;
  margin-right: 5px;
  color: #4caf !important;
}

.invisible-button-style {
  width: 25px !important;
  height: 25px !important;
  min-width: 25px !important;
  min-height: 25px !important;
  padding: 0 !important;
  margin-right: 5px;
  color: transparent !important;
}

.tags-margin {
  margin-top: 2px !important;
  margin-bottom: 5px !important;
}
</style>
